import React from 'react'
import IgniteAIBanner from "./assets/images/igniteai-dashboard.webp";

const IgniteAIBody = () => {
    return (
        <>
            <section className="wrapper productpagebody ignite-page">
                <section className="ecom-body">
                    <div className="container">
                        <h2 className="text-center fw-medium margin-set fs-56px mb-4">
                            Unlock AI-powered insights for smarter decisions
                        </h2>
                        <div className="row justify-content-center">
                            <div className="col-md-8 my-2">
                                <div className="d-flex gap-3 flex-wrap justify-content-center justify-content-md-between">
                                    <div className="divido-mob-img">
                                        <img src={IgniteAIBanner} alt="IgniteAI Banner" />
                                    </div>
                                </div>
                                <p className="text-end mt-16x">
                                    <a href="https://www.figma.com/proto/lIQ5AvP3ZyKnwXHij0BcYj/FireAi?page-id=0%3A1&node-id=17-831&viewport=-1445%2C505%2C0.31&t=opmxqdYXnDnQoWMy-1&scaling=min-zoom&content-scaling=fixed" target="_blank" className="proto-link">View Here</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='ignite-content-block container'>
                    <div className='ignite-content-list'>
                        <h3 className='i-c-title'>Complex Data Retrieval Simplified</h3>
                        <div className='i-c-l-item-block'>
                            <div className='i-c-l-i-b-item'>
                                <p className='i-c-l-txt i-c-l-title'>Problem:</p>
                                <p className='i-c-l-txt i-c-l-subtxt'>HR teams need a structured way to manage employee records (add, edit, delete, and search employees) without feeling overwhelmed.</p>
                            </div>
                            <div className='i-c-l-i-b-item'>
                                <p className='i-c-l-txt i-c-l-title'>Solution:</p>
                                <ul className='ps-5'>
                                    <li className='i-c-l-txt i-c-l-subtxt'>AI Chat & Voice Input allows users to ask natural language questions for instant insights.</li>
                                    <li className='i-c-l-txt i-c-l-subtxt'>Clean UI with minimal clicks ensures quick access to key business metrics.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='ignite-content-list'>
                        <h3 className='i-c-title'>Data Clarity</h3>
                        <div className='i-c-l-item-block'>
                            <div className='i-c-l-i-b-item'>
                                <p className='i-c-l-txt i-c-l-title'>Problem:</p>
                                <p className='i-c-l-txt i-c-l-subtxt'>Users get overwhelmed by too much raw data.</p>
                            </div>
                            <div className='i-c-l-i-b-item'>
                                <p className='i-c-l-txt i-c-l-title'>Solution:</p>
                                <ul className='ps-5'>
                                    <li className='i-c-l-txt i-c-l-subtxt'><span className='fw-500'>Key Insights</span> provides summarized trends (e.g., September had the highest revenue).</li>
                                    <li className='i-c-l-txt i-c-l-subtxt'><span className='fw-500'>Visual Hierarchy:</span> Large, bold numbers for revenue, profit, and conversion rate help users focus on critical data first.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='ignite-content-list'>
                        <h3 className='i-c-title'>Better Visualization for Decision Making</h3>
                        <div className='i-c-l-item-block'>
                            <div className='i-c-l-i-b-item'>
                                <p className='i-c-l-txt i-c-l-title'>Problem:</p>
                                <p className='i-c-l-txt i-c-l-subtxt'><span className='fw-500'>Traditional dashboards make it difficult</span> to compare sales and performance data.</p>
                            </div>
                            <div className='i-c-l-i-b-item'>
                                <p className='i-c-l-txt i-c-l-title'>Solution:</p>
                                <ul className='ps-5'>
                                    <li className='i-c-l-txt i-c-l-subtxt'><span className='fw-500'>Line Graph for Revenue Trends:</span> Clearly distinguishes actual revenue vs. target over time.</li>
                                    <li className='i-c-l-txt i-c-l-subtxt'><span className='fw-500'>Pie & Bar Charts:</span> Easy to compare sales by state, gender, and e-commerce platform at a glance.</li>
                                    <li className='i-c-l-txt i-c-l-subtxt'><span className='fw-500'>Spider Chart for State-wise Sales:</span> Shows regional performance comparisons in a compact format.</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className='ignite-content-list'>
                        <h3 className='i-c-title'>Accessibility and Inclusivity</h3>
                        <div className='i-c-l-item-block'>
                            <div className='i-c-l-i-b-item'>
                                <p className='i-c-l-txt i-c-l-title'>Problem:</p>
                                <p className='i-c-l-txt i-c-l-subtxt'>Some users may struggle with reading complex numbers or using text input.</p>
                            </div>
                            <div className='i-c-l-i-b-item'>
                                <p className='i-c-l-txt i-c-l-title'>Solution:</p>
                                <ul className='ps-5'>
                                    <li className='i-c-l-txt i-c-l-subtxt'><span className='fw-500'>Voice Command Support</span> makes it easy for users who prefer speaking over typing.
                                        Gender Diversity Representation ensures <span className='fw-500'>inclusive analytics, respecting all identities.</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
            </section>
        </>
    )
}

export default IgniteAIBody
